import { A9Service, AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { CustomerContactAdd, CustomerContactPatch, CustomerContactUpdate, RsCustomerContact, RsCustomerContactInfo } from 'common/customers/services';

export interface ICustomerContactDataProvider
    extends IDataProviderV2<RsCustomerContact, RsCustomerContactInfo, CustomerContactAdd, CustomerContactUpdate, CustomerContactPatch> {
    add(item, resourceParams): Promise<RsCustomerContactInfo>;
    findMainContact(resourceParams: { customerId: number }): Promise<RsCustomerContactInfo>;
    distanceRecalculateAllAsync(resourceParams: { customerId: number }): Promise<{ id: number }>;
}

@A9Service('customerContactDataProvider')
export class CustomerContactDataProvider
    extends AbstractDataProviderV2<RsCustomerContact, RsCustomerContactInfo, CustomerContactAdd, CustomerContactUpdate, CustomerContactPatch>
    implements ICustomerContactDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/contacts');
    }

    public add(item, resourceParams = {}): Promise<RsCustomerContactInfo> {
        return this.getNextOrderNo(resourceParams).then((orderNo: number) => {
            item.orderNo = orderNo;

            return super.add(item, resourceParams);
        });
    }

    public findMainContact(resourceParams: { customerId: number }): Promise<RsCustomerContactInfo> {
        const url = this.helper.buildUrl(this.url, resourceParams) + '/findMainContact';

        return this.service.getItem<RsCustomerContactInfo>(url);
    }

    public distanceRecalculateAllAsync(resourceParams: { customerId: number }): Promise<{ id: number }> {
        // #40267, customerId = 0
        const url = this.helper.buildUrl(this.url, resourceParams) + '/distance/recalculate-all/async';

        return this.service.updateRequest(url, 'PUT', {});
    }

    private getNextOrderNo(resourceParams = {}): Promise<number> {
        return this.all({}, resourceParams).then((items: RsCustomerContact[]) => {
            let orderNo = 0;

            items.forEach((item: any) => (orderNo = Math.max(orderNo, item.orderNo)));

            return orderNo + 1;
        });
    }
}
